<template>
  <div :class="$style.container">
    <ItemTable
      v-bind="itemTableProps"
      :class="!fullHeight && $style.gSuiteImportTable"
      :columns="columns"
      :disableBulkAction="tableImportConditions.disableImportUsers"
      :disableSelectAllItems="tableImportConditions.disableSelectAllUsers"
      :disableSelectItems="tableImportConditions.disableSelectUsers"
    />
  </div>
</template>

<script>
import {
  FilterComponentConsts,
  ItemTypeConsts,
  StoreModuleMap,
} from 'client/util/Constants';
import { mapActions } from 'vuex';
import ItemTable from 'client/components/ItemTable/ItemTable.vue';

const storeModule = StoreModuleMap[ItemTypeConsts.gSuite];

export default {
  name: 'GSuiteImportSelection',

  components: {
    ItemTable,
  },

  props: {
    fullHeight: {
      default: false,
      type: Boolean,
    },
    gSuiteId: {
      type: String,
      required: true,
    },
    handleBulkAction: {
      default: () => {},
      type: Function,
    },
    showResults: {
      default: () => {},
      type: Function,
    },
    tableImportConditions: {
      default: () => ({}),
      type: Object,
    },
  },

  data() {
    return {
      itemTableProps: {
        legacyRowStyles: false,
        details: false,
        inPanel: false,
        hasSelectColumn: true,
        hideSelectionTotalCount: true,
        itemType: ItemTypeConsts.gSuite,
        selectionItemText: {
          label: 'selected',
          plural: 'users',
          singular: 'user',
        },
        showActionBar: true,
        showBound: false,
        showBulkAction: false,
        showSearchForm: true,
        useDropDownFilterComponent: FilterComponentConsts.GSuiteImportSelectionDropDownFilter,
        useLargeTableCells: true,
      },
    };
  },

  computed: {
    columns() {
      return [
        {
          bodyComponent: 'EditableInput',
          bodyComponentProps: {
            field: 'firstname',
            hideErrorValidation: true,
            showReadOnly: true,
            storeModule,
            type: 'text',
          },
          headingText: 'First Name',
          sortBy: 'GIVEN_NAME',
        },
        {
          bodyComponent: 'EditableInput',
          bodyComponentProps: {
            field: 'lastname',
            hideErrorValidation: true,
            showReadOnly: true,
            storeModule,
            type: 'text',
          },
          headingText: 'Last Name',
          sortBy: 'FAMILY_NAME',
        },
        {
          bodyComponent: 'EditableInput',
          bodyComponentProps: {
            field: 'email',
            hideErrorValidation: true,
            showReadOnly: true,
            storeModule,
            type: 'email',
            validation: 'required|email',
          },
          headingText: 'Email',
          sortBy: 'EMAIL',
        },
        {
          bodyComponent: 'ImportStatus',
          bodyComponentProps: {
            field: 'isNew',
          },
          classNames: {
            body: ['importStatusColumn'],
          },
          headingText: 'Status',
        },
      ];
    },
  },

  mounted() {
    this.setGSuiteId({
      gSuiteId: this.$props.gSuiteId,
    });
  },

  methods: {
    ...mapActions(storeModule, [
      'setGSuiteId',
    ]),
  },
};
</script>

<style module>
.container {
  height: 100%;
}

.gSuiteImportTable {
  height: 90% !important;
}
</style>
